import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "impureSearch",
  pure: false,
  standalone: false
})
export class ImpureSearchPipe implements PipeTransform {
  transform(value: any, search: string, searcharea: string[]): any {
    if (search !== undefined) {
      const regex = new RegExp(search, "i");
      const data: any = [];
      value.forEach((element: any) => {
        let flag = false;
        searcharea.forEach((ele) => {
          const main = ele.split(".");

          if (main.length > 1 ? element[main[0]][main[1]].match(regex) : element[main[0]].match(regex)) {
            flag = true;
          }
        });
        if (flag) {
          data.push(element);
        }
      });
      return data;
    }
    return value;
  }
}
